<div class="app-themed-image">
  <lib-refuse-image *ngIf="name === ThemedImageName.Refuse"></lib-refuse-image>
  <lib-save-image *ngIf="name === ThemedImageName.Save"></lib-save-image>
  <lib-send-image *ngIf="name === ThemedImageName.Send"></lib-send-image>
  <lib-error-image *ngIf="name === ThemedImageName.Error"></lib-error-image>
  <lib-puzzle-image *ngIf="name === ThemedImageName.Puzzle"></lib-puzzle-image>
  <lib-sign-image *ngIf="name === ThemedImageName.Sign"></lib-sign-image>
  <lib-delete-image *ngIf="name === ThemedImageName.Delete"></lib-delete-image>
  <lib-check-image *ngIf="name === ThemedImageName.Check"></lib-check-image>
</div>
